module.exports = __webpack_public_path__ + "static/img/sence-selected-bg.44f2cdf6.png";